import { useCallback, useEffect, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import {
  findSpend,
  findStatusWithFallback,
  getMapKey,
  prepareSpendMaps,
  SPEND_COLUMNS
} from './SupplierDataGridUtils';
import { ByUnitsUnitGroupDetailPanelContent } from './ByUnitsUnitGroupDetailPanelContent';
import { supplierDataGridSx } from './supplierDataGridStyles';

const unitGroupColumns = [
  {
    field: 'name',
    headerName: 'Unit Group',
    width: 600
  },
  ...SPEND_COLUMNS
];

export default function SupplierDataGridByUnits(props) {
  const { unitGroups, suppliers, updateSupplierStatus, isEdit } = props;

  function prepareSupplier(
    dataRows,
    splr,
    unit,
    unitGroup,
    masterInvoiceSpendMap,
    masterForecastSpendMap
  ) {
    if (splr && unit && unitGroup) {
      let mapKey = getMapKey(unit.code, splr.supplierNumber);
      let obj = {
        id: dataRows.length,
        number: splr.supplierNumber,
        name: splr.supplierName,
        statusScope: unit.code,
        status: findStatusWithFallback(splr, unitGroup.code, unit.code),
        r12Spend: findSpend(masterInvoiceSpendMap, mapKey),
        r12Forecast: findSpend(masterForecastSpendMap, mapKey),
        parentStatusScope: unitGroup.code
      };

      dataRows.push(obj);
    }
  }

  function prepareUnitRow(
    dataRows,
    suppliers,
    unit,
    unitGroup,
    { masterInvoiceSpendMap, masterForecastSpendMap }
  ) {
    if (suppliers) {
      const suppliersSpend = [];

      // Prepare Suppliers Spend
      suppliers.forEach((splr) =>
        prepareSupplier(
          suppliersSpend,
          splr,
          unit,
          unitGroup,
          masterInvoiceSpendMap,
          masterForecastSpendMap
        )
      );

      // Unit Object
      let obj = {
        id: dataRows.length,
        name: unit.name + ' - ' + unit.code,
        r12Spend: findSpend(masterInvoiceSpendMap, unit.code),
        r12Forecast: findSpend(masterForecastSpendMap, unit.code),
        suppliersSpend: suppliersSpend
      };

      dataRows.push(obj);
    }
  }

  function prepareUnitGroupRow(dataRows, suppliers, unitGroup, masterSpendObj) {
    if (suppliers && unitGroups) {
      const { masterInvoiceSpendMap, masterForecastSpendMap } = masterSpendObj;
      const unitsSpend = [];

      // Prepare Units Spend
      unitGroup.units.forEach((unit) =>
        prepareUnitRow(unitsSpend, suppliers, unit, unitGroup, masterSpendObj)
      );

      // Group Object
      let obj = {
        id: dataRows.length,
        name: unitGroup.name,
        r12Spend: findSpend(masterInvoiceSpendMap, unitGroup.code),
        r12Forecast: findSpend(masterForecastSpendMap, unitGroup.code),
        unitsSpend: unitsSpend
      };

      dataRows.push(obj);
    }
  }

  function prepareData(suppliers, unitGroups) {
    const dataRows = [];
    const masterSpendObj = prepareSpendMaps(suppliers);

    unitGroups?.forEach((unitGroup) =>
      prepareUnitGroupRow(dataRows, suppliers, unitGroup, masterSpendObj)
    );
    setRows(dataRows);
  }

  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (suppliers && unitGroups) prepareData(suppliers, unitGroups);
  }, [suppliers, unitGroups]);

  // const getDetailPanelHeight = useCallback(
  //   () => (getEnvVar('VITE_ENV') === 'local' ? 300 : 'auto'),
  //   []
  // );
  const getDetailPanelHeight = useCallback(() => 'auto', []);

  const getUnitGroupDetailPanelContent = useCallback(
    ({ row }) => (
      <ByUnitsUnitGroupDetailPanelContent
        updateSupplierStatus={updateSupplierStatus}
        row={row}
        isEdit={isEdit}
      />
    ),
    [isEdit]
  );

  return (
    <DataGridPro
      density="compact"
      getRowHeight={() => 'auto'}
      slots={{
        detailPanelExpandIcon: () => <fuel-icon name="content_expand" />,
        detailPanelCollapseIcon: () => <fuel-icon name="content_collapse" />
      }}
      columns={unitGroupColumns}
      rows={rows}
      getDetailPanelHeight={getDetailPanelHeight}
      getDetailPanelContent={getUnitGroupDetailPanelContent}
      sx={supplierDataGridSx}
    />
  );
}
